import { useGetEnrollmentStatusHistory } from '@actions';
import { LoadingSpinner } from '@components/LoadingSpinner/LoadingSpinner';
import { ENROLLMENT_STATUS_TYPES } from '@shared/constants';
import { ActiveEnrollmentStatuses, EnrollmentStatusTypes } from '@shared/enums';
import { mergeClassNames } from 'apps/agora/src/utils/helpers';
import moment from 'moment';
import { useMemo } from 'react';
import SessionModalSection from '../../DetailsModalSection';

interface EnrollmentStatusHistorySectionProps {
  enrollmentId: string;
}

const EnrollmentStatusHistorySection = (props: EnrollmentStatusHistorySectionProps) => {
  const { enrollmentId } = props;

  const { data: statuses, isLoading } = useGetEnrollmentStatusHistory(enrollmentId);

  const reversedStatuses = useMemo(() => [...(statuses ?? [])].reverse(), [statuses]);

  return (
    <SessionModalSection sectionTitle={'Status History'} className="flex flex-col gap-1">
      {isLoading && <LoadingSpinner className="mx-auto" />}

      {!isLoading &&
        reversedStatuses.map((status, index) => (
          <div
            key={status.createdAt.toString()}
            className={mergeClassNames('flex flex-col  px-2 py-1 bg-surfaceBackground', {
              'bg-surfaceHover': index === 0,
            })}
          >
            <div className="flex items-center gap-1">
              <span
                className={mergeClassNames('text-sm font-bold text-customPrimary', {
                  'text-customRedAccent':
                    !ActiveEnrollmentStatuses.includes(status.status) &&
                    status.status !== EnrollmentStatusTypes.Completed,
                })}
              >
                {ENROLLMENT_STATUS_TYPES[status.status]}
              </span>
              <span className="text-xs text-customGrey">
                {moment(status.createdAt).format('DD MMM YYYY, HH:mm')}
              </span>
              <span className="text-xs text-customGrey">
                by<span className="font-bold"> {status.createdBy}</span>
              </span>
            </div>
            <p className="text-sm text-customGrey">{status.reason}</p>
          </div>
        ))}
    </SessionModalSection>
  );
};

export default EnrollmentStatusHistorySection;
